<div class="container-fluid gx-12">
    <div class="row">
        <div class="col-6">
            
        </div>
        <div class="col-6"></div>
    </div>
</div>
